export default __webpack_public_path__ + "static/media/discord-icon.27583b53.svg";